import React from 'react'
import Delivery from './Delivery'
import { SimpleSpinner } from '../common/SimpleSpinner'
import { format } from 'date-fns'

export const DeliveryListNoDeliveries = selectedDate => (
  <div className="todaysstores-none">
    <div className="todaysstores-none_header">
      {format(Date.now(), 'dddd/MMMM/YYYY') ===
      format(selectedDate.selectedDate, 'dddd/MMMM/YYYY') ? (
        <span>There are no deliveries scheduled for Today</span>
      ) : (
        <span>
          There are no deliveries scheduled for{' '}
          {format(selectedDate.selectedDate, 'dddd')}.
        </span>
      )}
    </div>
    <div className="todaysstores-none_description">
      Check out the other days to see what's ahead. And don't forget, you can
      place your order for a future day in advance!
    </div>
  </div>
)

const DeliveryList = ({
  locationId,
  deliveries,
  selectDelivery,
  loadingNewDay,
  isSelectedDayActive,
  selectedDate,
  friendHasOrdered
}) => (
  <div>
    {isSelectedDayActive && loadingNewDay ? (
      <SimpleSpinner />
    ) : (
      <div className="todaysstores">
        {deliveries && deliveries.length ? (
          <ul>
            {deliveries.map(delivery => {
              return (
                <li key={delivery.deliveryId}>
                  <Delivery
                    locationId={locationId}
                    friendHasOrdered={
                      friendHasOrdered &&
                      friendHasOrdered.find(
                        order => order.dropoffId === delivery.deliveryDropoffId
                      )
                    }
                    delivery={delivery}
                    selectDelivery={selectDelivery}
                  />
                </li>
              )
            })}
          </ul>
        ) : (
          <DeliveryListNoDeliveries selectedDate={selectedDate} />
        )}
      </div>
    )}
  </div>
)

export default DeliveryList
